import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Tenant-wide list of known property addresses (+ unit variants), cached per session.
let _cache = null;
let _promise = null;
const listeners = new Set();

export function loadKnownAddresses(force = false) {
  if (_cache && !force) return Promise.resolve(_cache);
  if (_promise && !force) return _promise;
  _promise = api.get("/properties/list").then(r => {
    const out = [];
    (r.data.properties || []).forEach(p => {
      if (!p.address || p.former) return;
      out.push(p.address);
      (p.units || []).forEach(u => {
        if (u.unit && u.unit !== "1") out.push(`${p.address}, Unit ${String(u.unit).replace(/^unit\s*/i, "")}`);
      });
    });
    _cache = [...new Set(out)].sort();
    listeners.forEach(fn => fn(_cache));
    return _cache;
  }).catch(() => _cache || []).finally(() => { _promise = null; });
  return _promise;
}

export function useKnownAddresses() {
  const [list, setList] = useState(_cache || []);
  useEffect(() => {
    listeners.add(setList);
    loadKnownAddresses();
    return () => listeners.delete(setList);
  }, []);
  return list;
}

export function matchKnownAddresses(list, q, limit = 6) {
  const s = (q || "").trim().toLowerCase();
  if (s.length < 2) return [];
  const toks = s.split(/\s+/);
  return list.filter(a => { const l = a.toLowerCase(); return toks.every(t => l.includes(t)); }).slice(0, limit);
}

// Mount once per shell so any <input list="known-addresses"> gets suggestions.
export function KnownAddressDatalist() {
  const list = useKnownAddresses();
  return <datalist id="known-addresses">{list.map(a => <option key={a} value={a}/>)}</datalist>;
}
